export default __webpack_public_path__ + "static/media/step_C_UA.47e31037.png";